import React from 'react';
import PropTypes from 'prop-types';

const Button = props => {

    const { styles, text, url } = props;

    return (
        <a 
            className="d-inline-block mt-3 rounded-pill py-2 py-md-3 px-4 px-md-5 btn-start" 
            href={url}
            style={styles}
        >
            {text}
        </a>
    )
}

export default Button;

Button.propTypes = {    
    styles: PropTypes.object.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}
